import * as yup from 'yup'
import { TFunction } from 'react-i18next'

export function buildValidationSchema(t: TFunction): yup.AnyObjectSchema {
  return yup.object().shape({
    email: yup
      .string()
      .label(t('saasAdmins.form.email.label'))
      .email(t('validations.email'))
      .required(({ label }) => t('validations.required', { label })),
    profile: yup
      .string()
      .required(({ label }) => t('validations.required', { label })),
  })
}
